<div class="n-oldalfej">
  <div>
    <h2>Cégtelefon magáncélú használata</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · egyes meghatározott juttatás, havonta munkavállalónként</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="ment()" [disabled]="mentes || !betoltve"><ion-icon slot="start" name="save-outline"></ion-icon>Mentés</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId && betoltve">
  <div class="n-szuro-sor">
    <span class="cimke">Egyszerűsített: a számlaérték {{ szazalek(param?.telefon_magan_hanyad) }}%-a</span>
    <span class="cimke">Adóalap: érték × {{ tizedes(param?.adoalap_szorzo) }}</span>
    <span class="cimke sarga" *ngIf="kivas">KIVA-alany: szocho helyett KIVA-alap</span>
    <span class="cimke sarga" *ngIf="valtozott">Nem mentett változás</span>
    <div class="spacer"></div>
    <button type="button" class="ov-gomb" (click)="elozoHonap()" title="Az előző hónap számlaértékei azoknál, akiknél még nincs adat">
      <ion-icon name="copy-outline"></ion-icon>Előző hónap átvétele</button>
    <button type="button" class="ov-gomb" (click)="nyomtat()"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button>
    <button type="button" class="ov-gomb" (click)="parameterek()"><ion-icon name="options-outline"></ion-icon>Paraméterek</button>
  </div>

  <div class="ures" *ngIf="!sorok.length">
    <ion-icon name="call-outline"></ion-icon>
    {{ aktiv.ev }}. {{ honapNev(aktiv.ho) | lowercase }} hónapban nincs foglalkoztatott munkavállaló. Munkavállalót az Alkalmazotti törzsben lehet felvenni.
  </div>

  <div class="tabla-wrap" *ngIf="sorok.length">
    <table class="n-racs jt-racs">
      <thead><tr>
        <th>Munkavállaló</th>
        <th class="num">Számlaérték (bruttó)</th>
        <th>Magáncélú rész</th>
        <th class="num">Magáncélú (Ft)</th>
        <th class="num">Megtérítés</th>
        <th class="num cs-afa">Juttatás értéke</th>
        <th class="num cs-afa">Adóalap</th>
        <th class="num cs-penz">SZJA ({{ szazalek(param?.szja_kulcs) }}%)</th>
        <th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho (' + szazalek(param?.szocho_kulcs) + '%)' }}</th>
        <th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let s of sorok" [class.jt-halvany]="!(+s.koltseg > 0)">
          <td><b>{{ s.nev }}</b><span class="halvany" *ngIf="s.adoazonosito"> · {{ s.adoazonosito }}</span></td>
          <td class="num jt-cella"><input type="number" min="0" [(ngModel)]="s.koltseg" (ngModelChange)="jelol()" placeholder="0"></td>
          <td class="jt-cella">
            <select [(ngModel)]="s.szamitas" (ngModelChange)="jelol()">
              <option value="egyszerusitett">Egyszerűsített ({{ szazalek(param?.telefon_magan_hanyad) }}%)</option>
              <option value="tetelesen">Tételesen</option>
            </select>
          </td>
          <td class="num jt-cella">
            <input *ngIf="s.szamitas === 'tetelesen'; else szamitott" type="number" min="0" [(ngModel)]="s.magan_resz" (ngModelChange)="jelol()" placeholder="0">
            <ng-template #szamitott>{{ ft(magan(s)) }}</ng-template>
          </td>
          <td class="num jt-cella"><input type="number" min="0" [(ngModel)]="s.megterites" (ngModelChange)="jelol()" placeholder="0"></td>
          <td class="num cs-afa">{{ ft(ertek(s)) }}</td>
          <td class="num cs-afa">{{ ft(adoalap(s)) }}</td>
          <td class="num cs-penz">{{ ft(szja(s)) }}</td>
          <td class="num cs-penz">{{ ft(kivas ? adoalap(s) : szocho(s)) }}</td>
          <td class="ber-muv">
            <button type="button" class="kv-mini" (click)="ujVonal(s)" title="Újabb telefonvonal ennek a munkavállalónak"><ion-icon name="add-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torolSor(s)" title="A sor törlése (mentéskor)"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
      <tfoot><tr *ngIf="osszesen as o">
        <td>Összesen</td>
        <td class="num">{{ ft(o.koltseg) }}</td>
        <td></td>
        <td class="num">{{ ft(o.magan) }}</td>
        <td class="num">{{ ft(o.megterites) }}</td>
        <td class="num cs-afa">{{ ft(o.ertek) }}</td>
        <td class="num cs-afa">{{ ft(o.adoalap) }}</td>
        <td class="num cs-penz">{{ ft(o.szja) }}</td>
        <td class="num cs-penz">{{ ft(kivas ? o.adoalap : o.szocho) }}</td>
        <td></td>
      </tr></tfoot>
    </table>
  </div>

  <div class="n-panel ata-info jt-info">
    <div class="n-panel-cim">Hogyan számol</div>
    <ul>
      <li>A munkáltató által üzleti célra adott telefon <b>magáncélú használata</b> egyes meghatározott juttatás (Szja tv. 70. § (1) b)).</li>
      <li><b>Magáncélú rész</b>: tételesen (pl. hívásrészletező alapján), vagy egyszerűsítve a számlaérték (ÁFA-val)
        {{ szazalek(param?.telefon_magan_hanyad) }}%-a. Amit a munkavállaló megtérít, az nem juttatás.</li>
      <li><b>Adóalap</b> = a meg nem térített magáncélú rész × {{ tizedes(param?.adoalap_szorzo) }}; SZJA {{ szazalek(param?.szja_kulcs) }}%,
        <ng-container *ngIf="!kivas">szocho {{ szazalek(param?.szocho_kulcs) }}%.</ng-container>
        <ng-container *ngIf="kivas">szocho helyett az adóalap a <b>KIVA alapjába</b> tartozik (személyi jellegű kifizetés).</ng-container></li>
      <li>A közterheket a juttatás negyedévét követő hónap 12-éig kell bevallani és megfizetni (NAV 49. füzet).</li>
      <li>A táblázat élőben számol; a mentéskor a kiszolgáló a hónap sorait az aktuális paraméterekkel tárolja.</li>
    </ul>
  </div>
</ng-container>

<ion-modal #paramModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Paraméterek – {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="paramModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-ber-juttatas-param [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [csoportok]="['telefon', 'kozos']" (mentve)="paramMentve()"></app-ber-juttatas-param>
    </div>
  </ng-template>
</ion-modal>
